import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { useGameStore } from './stores/gameStore'

// 导入全局样式
import './styles/global.css'

// Mount root app with Pinia for state management
const app = createApp(App)
app.use(createPinia())

// 简易 $router 适配，支持新的路由参数格式和旧的查询参数格式
app.config.globalProperties.$router = {
  push: (to) => {
    if (typeof to === 'string') {
      router.push(to)
    } else if (to.name === 'game') {
      // 使用新的 SEO 友好的 URL 格式：/games/{game}/{mode|difficulty}
      const mode = to.query?.mode || 'classic'
      router.push(`/games/poker/${encodeURIComponent(mode)}`)
    } else {
      router.push('/')
    }
  }
}

// 进入 /games/poker/:mode 时启动游戏并设置模式
function handleRoute() {
  const path = router.getPath()
  const query = router.getQuery()
  const store = useGameStore()

  // 处理新的路由格式：/games/poker/:mode
  if (path.startsWith('/games/poker/')) {
    const params = router.getParams('/games/poker/:mode')
    const allowed = ['classic','lightning','coop']
    const prevMode = store.gameMode
    const mode = params.mode || query.mode // 支持向后兼容
    const hasRequested = mode && allowed.includes(mode)

    if (hasRequested) {
      store.gameMode = mode
    }
    const modeChanged = hasRequested ? prevMode !== store.gameMode : false
    if (modeChanged || store.gameState !== 'playing') {
      if (!hasRequested && !allowed.includes(store.gameMode)) {
        store.gameMode = 'classic'
      }
      store.startGame()
    }
  }
  // 兼容旧格式：/game?mode=xxx
  else if (path === '/game') {
    const allowed = ['classic','lightning','coop']
    const prevMode = store.gameMode
    const hasRequested = query.mode && allowed.includes(query.mode)
    if (hasRequested) {
      store.gameMode = query.mode
    }
    const modeChanged = hasRequested ? prevMode !== store.gameMode : false
    if (modeChanged || store.gameState !== 'playing') {
      if (!hasRequested && !allowed.includes(store.gameMode)) {
        store.gameMode = 'classic'
      }
      store.startGame()
    }
  }
}

router.onChange(handleRoute)
handleRoute()

app.mount('#app')
